import { filter, includes, isEmpty } from "lodash-es";
import { userState, getDefaultClientId, refreshUserData } from "./UserState.svelte";
import { Identity } from "$lib/shared/services/IdentityService";
import { settingsRoutes } from "$lib/shared/routes";

export let authState = $state({
    isAuthenticated: false,
    clientId: "",
    identityToken: "",
    identityTokenParsed: {},
    currentTenant: null,
    tenantCount: 0
});

export function hasEditAccess(tenantId) {
    return authState.currentTenant.isGlobal
        || tenantId === authState.currentTenant.tenantId;
}

export function hasTenantAdminAccess() {
    let roles = $state.snapshot(authState.identityTokenParsed?.realm_access?.roles) ?? [];
    return includes(roles, "arc_tenant_admin");
}

export async function initializeSession(tokenValues) {
    updateToken(tokenValues);
    await refreshUserData(authState.clientId);
    let expectedClientId = getDefaultClientId();
    if(expectedClientId === authState.clientId) return;
    Identity.switchTenant(expectedClientId);
}

export function updateToken({ token="", tokenParsed={} }) {
    authState.identityToken = token;
    authState.identityTokenParsed = tokenParsed;
    authState.clientId = tokenParsed?.azp;
    authState.isAuthenticated = !!token;
}

export function clearToken() {
    authState.identityToken = "";
    authState.identityTokenParsed = {};
    authState.isAuthenticated = false;
    return true;
}

export function getSettingsRoutes() {
    let isGlobalTenant = authState.currentTenant.isGlobal;
    return filter(settingsRoutes, r =>
        (userState.isAdmin || !r.adminOnly)
            && (isGlobalTenant ? r.global : r.nonGlobal)
    );
}